import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { createStyles, makeStyles, Button, Container, Grid, Typography } from '@material-ui/core';
import Success from './img-connection-success.svg';
import { ViewIcon } from '../../../../icons/ViewIcon';
import { PrimaryButton } from '../../../common/PrimaryButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) =>
  createStyles({
    illustrationContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '@media screen and (max-width: 950px)': {
        justifyContent: 'center',
      },
    },
    viewButton: {
      marginTop: '0px',
      marginRight: '80px',
      '& svg': {
        position: 'relative',
        left: '-5px',
      },
      '@media screen and (max-width: 351px)': {
        marginLeft: '0px',
        marginRight: '0px',
        marginTop: '10px',
      },
    },
    image: {
      width: '245px',
      height: '320px',
      '@media screen and (max-width: 761px)': {
        marginTop: '12px',
        width: '30vh',
        height: 'auto',
        maxWidth: '100%',
      },
    },
    gridContainer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media screen and (max-width: 950px) and (min-width: 761px)': {
        display: 'flex',
        flexWrap: 'nowrap',
      },
      '@media screen and (max-width: 760px)': {
        justifyContent: 'center',
      },
    },
    buttonGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '@media screen and (max-width: 950px)': {
        justifyContent: 'flex-start',
      },
      '@media screen and (max-width: 351px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
  })
);

interface ConnectivitySuccessProps {
  openModal: () => void;
}

export function ConnectivitySuccess({ openModal }: ConnectivitySuccessProps) {
  const classes = useStyles();
  const { nextPane } = useAppStateContext();
  const { t } = useTranslation('', { keyPrefix: 'CONNECTION' });

  return (
    <>
      <Container>
        <Grid container className={classes.gridContainer}>
          <Grid item md={5}>
            <Typography variant="h1" gutterBottom>
              {t('CONNECTION_SUCCESS')}
            </Typography>

            <Typography variant="body1" gutterBottom>
              {t('CONNECTION_SUCCESS_DESCRIPTION')}
            </Typography>

            <Grid item className={classes.buttonGrid} direction="row">
              <PrimaryButton onClick={nextPane}>{t('OK')}</PrimaryButton>
              <Button
                color="primary"
                variant="outlined"
                disableRipple
                onClick={openModal}
                className={classes.viewButton}
              >
                <ViewIcon />
                {t('VIEW_DETAILED_INFORMATION')}
              </Button>
            </Grid>
          </Grid>

          <Grid item md={5} className={classes.illustrationContainer}>
            <img src={Success} alt="Success" className={classes.image} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
